import createSaga from './createSaga'
import deleteSaga from './deleteSaga'
import editCompaniesSaga from './editCompaniesSaga'
import editSaga from './editSaga'
import infoByTokenSaga from './infoByTokenSaga'
import listSaga from './listSaga'
import listSearchSaga from './listSearchSaga'
import oneSharedListSaga from './oneSharedListSaga'
import listWithCompanySaga from './listWithCompanySaga'
import selectCompaniesSaga from './selectCompaniesSaga'
import rejectCompaniesSaga from './rejectCompaniesSaga'
import selectCompaniesByTokenSaga from './selectCompaniesByToken'
import setUnavailableSlotsByTokenSaga from './setUnavailableSlotsByToken'
import getUnavilableSlotsByTokenSaga from './getUnavailableSlotsByToken'
import changeStatusSaga from './changeStatusSaga'

const sharedListsSaga = [
    createSaga(),
    editCompaniesSaga(),
    editSaga(),
    infoByTokenSaga(),
    listSaga(),
    listSearchSaga(),
    oneSharedListSaga(),
    listWithCompanySaga(),
    selectCompaniesSaga(),
    rejectCompaniesSaga(),
    selectCompaniesByTokenSaga(),
    setUnavailableSlotsByTokenSaga(),
    getUnavilableSlotsByTokenSaga(),
    deleteSaga(),
    changeStatusSaga()
]

export default sharedListsSaga
